export const SIDEBAR_WIDTH_FULL = "w-72",
  SIDEBAR_WIDTH_COLLAPSED = "w-20";
